module.exports = __webpack_public_path__ + "img/img2.c36fb255.svg";